import type { ComponentProps } from "react";
import React from "react";

import { cn } from "@/lib/helpers/cn";
import { getCurrentPolicyVersion } from "@/lib/helpers/getCurrentPolicyVersion";
import { getVersionedConsentHref } from "@/lib/helpers/getVersionedConsentHref";
import { Link2 } from "@/ui2/atoms/Link";
import type { PolicyMetaData } from "@/core/types";

type DisclaimerProps = ComponentProps<"p"> & {
  customDisclaimerPrefix?: string;
  policyMetadata: PolicyMetaData;
};

export function ConsentDisclaimer({
  className,
  customDisclaimerPrefix = null,
  policyMetadata,
}: DisclaimerProps) {
  const disclaimerPrefix =
    customDisclaimerPrefix || "By creating your account, you agree to aptihealth's";

  return (
    <p className={cn("body-sm tw:text-center", className)}>
      {disclaimerPrefix}{" "}
      <ConsentLink
        policy="eula"
        text="Terms and Conditions of Use"
        version={getCurrentPolicyVersion({ policy: "TERMS_AND_CONDITIONS", policyMetadata })}
      />
      ,{" "}
      <ConsentLink
        policy="privacy"
        text="Privacy Policy"
        version={getCurrentPolicyVersion({ policy: "PRIVACY", policyMetadata })}
      />
      , and{" "}
      <ConsentLink
        policy="hipaa"
        text="HIPAA Notice of Privacy Practices"
        version={getCurrentPolicyVersion({ policy: "HIPAA", policyMetadata })}
      />{" "}
    </p>
  );
}

type ConsentLinkProps = Parameters<typeof getVersionedConsentHref>[0] & {
  text: string;
};

function ConsentLink({ policy, text, version }: ConsentLinkProps) {
  return (
    <Link2 href={getVersionedConsentHref({ policy, version })} isExternal>
      {text}
    </Link2>
  );
}
